/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const VideoIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M13 11.976a.024.024 0 0 0 .049.004 2.88 2.88 0 0 1 1.422-1.995L18 8v9l-3.53-1.985a2.88 2.88 0 0 1-1.421-1.995.024.024 0 0 0-.049.004V17H2V8h11zM5 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4" />
    <path d="M10 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6" />
  </g>,
);
